// Utility for authenticated SSE using fetch + ReadableStream
// Usage: createAuthenticatedEventSource(url, token, onMessage, onError)

export function createAuthenticatedEventSource(
  url: string,
  token: string,
  onMessage: (event: { data: unknown }) => void,
  onError?: (err: Error) => void
) {
  fetch(url, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Accept': 'text/event-stream',
    },
  })
    .then(response => {
      if (!response.body) throw new Error('No response body');
      const reader = response.body.getReader();
      let buffer = '';
      const decoder = new TextDecoder();

      function read() {
        reader.read().then(({ done, value }) => {
          if (done) return;
          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || '';
          for (const line of lines) {
            if (line.startsWith('data:')) {
              try {
                const data = JSON.parse(line.slice(5));
                onMessage({ data });
              } catch {
                onMessage({ data: line.slice(5) });
              }
            }
          }
          read();
        }).catch(err => {
          if (onError) onError(err);
        });
      }
      read();
    })
    .catch(err => {
      if (onError) onError(err);
    });
}
